import CookieDeclaration from './cookieDeclaration'

export function cookieDeclarationFactory(data: any, key: string | number) {
  const content = data?.content?.properties
  return <CookieDeclaration title={content.title.markup} key={key} />
}
